<template>
    <li class="dropdown" :class="{'active': active === 'user'}">
        <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
            {{ shared.user.full_name }} <span class="caret"></span>
        </a>

        <ul class="dropdown-menu" role="menu">
            <li>
                <router-link to="/passwords/edit">
                    Change Password
                </router-link>
            </li>

            <li>
                <a href="#" @click.prevent="logout">
                    Log out
                </a>
            </li>
        </ul>
    </li>
</template>

<script>
    import http from '@/http'
    import store from '@/store'
    import Meta from '@/mixins/Meta'

    export default {
        mixins: [Meta],
        
        data() {
            return {
                shared: store
            }
        },

        computed: {
            active() {
                return this.getMeta('section')
            }
        },

        methods: {
            logout() {
                http.delete('/api/v1/tokens')
                    .then(() => {
                        this.shared.token = null

                        this.shared.user = null

                        localStorage.removeItem('token')

                        localStorage.removeItem('user')

                        this.$router.push('/login')
                    })
            }
        }
    }
</script>
